import * as React from 'react'
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import Jobs from './Jobs'
import AppBar from '@mui/material/AppBar';
import { Box, FormControl, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Select } from '@mui/material';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { defaultApi } from '../../../api-interface';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { TenantContext } from '../../..';
import GppGoodIcon from '@mui/icons-material/GppGood';
import UnstyledLink from '../UnstyledLink/UnstyledLink';
import MenuIcon from '@mui/icons-material/Menu';
import { mainNavbarItems } from '../../Navbar/consts/navbarListItems'


const Header = ({ title, tenants }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const tenant_id = React.useContext(TenantContext)
  const open = Boolean(anchorEl);
  const navigate = useNavigate()
  const handleLogout = async () => {
    await defaultApi.logoutLogoutPost()
    navigate("/login")
  }
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleTenantChange = (e) => {
    const url = window.location.href
    const url_array = url.split("/")
    console.log(url_array)
    url_array[4] = e.target.value
    navigate("/" + url_array.slice(3).join("/"))
  }
  const currentTenant = useContext(TenantContext)

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>

        <Typography variant="h6" sx={{ flexGrow: 1 }} noWrap component="div">
          <Box sx={{ flexGrow: 1, display: {xs: 'inline',  sm: 'inline', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {mainNavbarItems.map((page) => (
                <MenuItem key={page.id}
                  onClick={handleCloseNavMenu}
                >
                  <UnstyledLink key={page.id} to={page.route}>
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          {page.icon}
                        </ListItemIcon>
                        <ListItemText primary={page.label} />
                      </ListItemButton>
                    </ListItem>
                  </UnstyledLink>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <UnstyledLink to={`/dashboard/${currentTenant}/dashboard`}>
            <>
              <GppGoodIcon sx={{ display: { xs: 'none', sm: 'inline' }, paddingTop: "5px", position: "relative", top: "3px" }} fontSize='medium' />
              <Typography variant="h6" sx={{ display: { xs: 'none', sm: 'inline' }, marginLeft: "8px" }}>Nova Comply <Typography display={"inline"} fontSize={"0.7em"} fontStyle={"italic"}>(Beta)</Typography></Typography>
            </>
          </UnstyledLink>
        </Typography>

        <Jobs></Jobs>

        <Typography>
          <FormControl variant="standard">
            <Select
              // ew
              sx={{
                height: '2.5rem',
                color: 'white',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white'
                },
                '& .MuiSvgIcon-root': {
                  color: 'white'
                }
              }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={currentTenant}
              label="Tenant"
              disableUnderline
              onChange={(e) => { handleTenantChange(e) }}
            >
              {
                tenants.map((tenant) => (
                  <MenuItem color='inherit' key={tenant.id} value={tenant.id}>{tenant.name}</MenuItem>

                ))
              }
            </Select>
          </FormControl>
        </Typography>
        <Typography>
          <IconButton color='inherit' onClick={handleClick}><AccountCircleSharpIcon /></IconButton>
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={() => { navigate(`/dashboard/${tenant_id}/profile`); handleClose(); }}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Typography>
      </Toolbar>
    </AppBar>
  )
}

export default Header
